import { useState, useRef, useEffect } from 'react';
import { BOT_REPLIES } from '../data/products';
import './ChatAssistant.css';

const QUICK_REPLIES = [
  '📱 Best phones under $200?',
  '💻 Gaming laptops?',
  '🚚 Delivery info?',
  '💰 Current deals?',
];

function getReply(msg) {
  const m = msg.toLowerCase();
  if (m.includes('phone') || m.includes('iphone') || m.includes('samsung') || m.includes('xiaomi')) return BOT_REPLIES.phones;
  if (m.includes('laptop') || m.includes('macbook') || m.includes('computer') || m.includes('gaming')) return BOT_REPLIES.laptop;
  if (m.includes('deliver') || m.includes('ship')) return BOT_REPLIES.deliver;
  if (m.includes('deal') || m.includes('discount') || m.includes('sale') || m.includes('offer')) return BOT_REPLIES.deal;
  if (m.includes('price') || m.includes('cost') || m.includes('pay') || m.includes('ecocash')) return BOT_REPLIES.price;
  if (m.includes('contact') || m.includes('call') || m.includes('whatsapp') || m.includes('reach')) return BOT_REPLIES.contact;
  if (m.includes('warranty') || m.includes('genuine') || m.includes('return')) return BOT_REPLIES.warranty;
  return BOT_REPLIES.default;
}

export default function ChatAssistant() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { id: 1, text: "👋 Hey! Welcome to **LastTech** — Zimbabwe's best tech store! I'm the assistant for **Last Maisiri**.\n\nHow can I help you today?", isBot: true, time: 'Just now' }
  ]);
  const [input, setInput] = useState('');
  const [typing, setTyping] = useState(false);
  const messagesRef = useRef(null);

  useEffect(() => {
    if (messagesRef.current) messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
  }, [messages, typing]);

  const now = () => new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  const sendMsg = (text) => {
    if (!text.trim()) return;
    const userMsg = { id: Date.now(), text, isBot: false, time: now() };
    setMessages(prev => [...prev, userMsg]);
    setInput('');
    setTyping(true);
    setTimeout(() => {
      setTyping(false);
      setMessages(prev => [...prev, { id: Date.now() + 1, text: getReply(text), isBot: true, time: now() }]);
    }, 1000 + Math.random() * 600);
  };

  const formatText = (text) =>
    text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br/>');

  return (
    <>
      <button className={`chat-toggle ${open ? 'open' : ''}`} onClick={() => setOpen(!open)}>
        {open ? '✕' : '💬'}
      </button>

      <div className={`chat-window ${open ? 'open' : ''}`}>
        <div className="chat-header">
          <div className="chat-avatar">⚡</div>
          <div className="chat-agent-info">
            <div className="chat-agent-name">LastTech Assistant</div>
            <div className="chat-agent-status">
              <span className="chat-status-dot" />
              Online — Last Maisiri
            </div>
          </div>
          <button className="chat-close" onClick={() => setOpen(false)}>✕</button>
        </div>

        <div className="chat-messages" ref={messagesRef}>
          {messages.map(msg => (
            <div key={msg.id} className={`msg ${msg.isBot ? 'msg-bot' : 'msg-user'}`}>
              <div className="msg-bubble" dangerouslySetInnerHTML={{ __html: formatText(msg.text) }} />
              <div className="msg-time">{msg.time}</div>
            </div>
          ))}
          {typing && (
            <div className="msg msg-bot">
              <div className="typing-dots">
                <div className="typing-dot" />
                <div className="typing-dot" />
                <div className="typing-dot" />
              </div>
            </div>
          )}
        </div>

        <div className="chat-quick-replies">
          {QUICK_REPLIES.map(q => (
            <button key={q} className="quick-reply" onClick={() => sendMsg(q)}>{q}</button>
          ))}
        </div>

        <div className="chat-input-row">
          <input
            type="text"
            className="chat-input"
            placeholder="Type a message..."
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && sendMsg(input)}
          />
          <button className="chat-send" onClick={() => sendMsg(input)}>➤</button>
        </div>

        <a
          href="https://wa.me/263713508064?text=Hi%20Last!%20I%20need%20help"
          target="_blank"
          rel="noreferrer"
          className="chat-wa-btn"
        >
          📱 Continue on WhatsApp with Last
        </a>
      </div>
    </>
  );
}
